import React, { useContext } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { AccountContext } from '../../../../components/AccountContext';

const i18n = defineMessages({
  dialogHeader: {
    id: 'company-information-different-from-billing-information-dialog.header',
    defaultMessage: 'Edit Company Data',
  },
  firstParagraph: {
    id: 'company-information-different-from-billing-information-dialog.first-paragraph',
    defaultMessage:
      'Please check the Invoice Address and the other Company Data found at Account Management / Account / Settings for this account.',
  },
  secondParagraph: {
    id: 'company-information-different-from-billing-information-dialog.second-paragraph',
    defaultMessage: 'Make sure that all data is correct and in accordance with all legal documents.',
  },
  button: {
    id: 'company-information-different-from-billing-information-dialog.button',
    defaultMessage: 'Edit Company Data',
  },
});

const CompanyInformationDifferentFromBillingInformationDialog = ({ visible }) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const currentAccount = useContext(AccountContext);

  const diaglogHeader = <div className="dashboard-panel-header">{formatMessage(i18n.dialogHeader)}</div>;

  return (
    <Dialog visible={visible} closable={false} header={diaglogHeader} onHide={() => {}}>
      <p>{formatMessage(i18n.firstParagraph)}</p>
      <p>{formatMessage(i18n.secondParagraph)}</p>
      <div className="mt20 flex-center">
        <Button
          type="button"
          className="p-button-primary"
          onClick={() => {
            history.push(`/accounts/${currentAccount}/settings?editCompanyData=true`);
          }}
          label={formatMessage(i18n.button)}
        />
      </div>
    </Dialog>
  );
};

CompanyInformationDifferentFromBillingInformationDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default CompanyInformationDifferentFromBillingInformationDialog;
